// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1jnVV","right":"styles_right__1QDJk"};